import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  padding-top: 8px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    padding-bottom: 24px;
  }
`;

export const ItemWrapper = styled.div<{ isSelected: boolean }>`
  display: flex;
  padding: 14px 16px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid;
  background: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.green6 : theme.colors.black4};
  background: ${({ theme, isSelected }) => (isSelected ? theme.colors.green1 : theme.colors.white)};
  transition: background 0.3s, border 0.1s;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.green6};
    background: ${({ theme }) => theme.colors.green1};
  }
`;
